import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid2';
import Toastmessage from "../../components/Toast";
import { logout } from "../../features/auth/AuthSlice";
import { authApi } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const formatCurrency = (value) => {
    if (typeof value === 'string' && value.includes('$')) {
        // Extract numeric part, parse it, and format as USD currency
        const numericValue = parseFloat(value.replace(/[$,]/g, ''));
        return isNaN(numericValue) ? value : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(numericValue);
    }
    return value;
};

const columns = [
    {
        field: 'metric',
        headerName: '',
        flex: 1,
        renderCell: (params) => (
            <span style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>
                {params.value}
            </span>
        ),
    },
    ...[
        'January', 'February', 'March', 'April', 'May', 'June', 'July',
        'August', 'September', 'October', 'November', 'December', 'Cumulative'
    ].map((month) => ({
        field: month,
        headerName: month,
        flex: 1,
        renderCell: (params) => (
            <span>{formatCurrency(params.value)}</span>
        ),
    }))
];


export default function IncentiveReports() {

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux
    const [data, setData] = useState([])

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [locations, setLocations] = useState([]);
    const [users, setUsers] = useState([]);
    const [years, setYears] = useState([]);
    const [types, setTypes] = useState([]);

    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);

 
    

    const handleDesignationChange = (event, newValue) => {
        setSelectedDesignation(newValue);
        fetcManageReport(newValue, selectedUser, selectedLocation, selectedYear)
    };
    
    const handleUserChange = (event, newValue) => {
        setSelectedUser(newValue);
        fetcManageReport(selectedDesignation, newValue, selectedLocation, selectedYear)

    };
    
    const handleLocationChange = (event, newValue) => {
        setSelectedLocation(newValue);
        fetcManageReport(selectedDesignation, selectedUser, newValue, selectedYear)

    };
    
    const handleYearChange = (event, newValue) => {
        setSelectedYear(newValue);
        fetcManageReport(selectedDesignation, selectedUser, selectedLocation, newValue)
    };
    

    // Define fetchLocations separately to reuse it
    const fetchYear = async () => {
        const input_token = 'TIMESHEET_MONTH_YEAR'; // Replace with your actual token
        const apiUrl = 'get_month_year'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setYears(data.year);
                // setLocationName(statesArray?.[0])

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    // Define fetchLocations separately to reuse it
    const fetchDesignation = async () => {
        const input_token = 'DESIGNATION'; // Replace with your actual token
        const apiUrl = 'list_of_designation'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.designations.map(location => ({
                    id: location.id,
                    name: location.designation_name, // Match `getOptionLabel`
                }));
                setTypes(statesArray)

                // setLocationOptions(statesArray);
                // setLocationName(statesArray?.[0])

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    // Define fetchLocations separately to reuse it
    const fetchUser = async () => {
        const input_token = 'ALL_EMPLOYEES'; // Replace with your actual token
        const apiUrl = 'list_of_all_employee'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.clients.map(location => ({
                    id: location.id,
                    name: location.full_name, // Match `getOptionLabel`
                    initial:location.initial
                }));

                setUsers(statesArray)

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };



    // Define fetchLocations separately to reuse it
    const fetchLocation = async () => {
        const input_token = 'LOCATIONS'; // Replace with your actual token
        const apiUrl = 'list_of_locations'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.locations.map(location => ({
                    id: location.id,
                    locationname: location.location_name, // Match `getOptionLabel`
                }));
                setLocations(statesArray)
                // setLocationOptions(statesArray);
                // setLocationName(statesArray?.[0])

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    // Define fetchLocations separately to reuse it
    const fetcManageReport = async (Designation, user , location , year) => {
        console.log(Designation, user , location?.id , year)
        const input_token = 'INCENTIVE_REPORT'; // Replace with your actual token
        const apiUrl = 'incentive_report'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            year: year,
            designation:Designation?.id || null,
            user: user?.initial || null,
            location: location?.id || null,
        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setData(data?.incentive_report)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    useEffect(() => {
        fetchYear();
        fetchDesignation();
        fetchUser();
        fetchLocation();
        fetcManageReport(selectedDesignation, selectedUser, selectedLocation, selectedYear);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box style={{ backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', padding: '16px' }}>
            <Box sx={{ width: '100%', padding: 2, backgroundColor: 'var(--theme-bg-light)', borderRadius: 2 }}>
                <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
                    Incentive Reports
                </Typography>
                <Grid container spacing={2} sx={{ marginBottom: 2 }}>

                    <Grid item size={{md: 2, xs: 12 }}>
                        <Typography>
                            Designation
                        </Typography>
                        <Autocomplete
                            options={types}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} placeholder="Select Designation" />}
                            value={selectedDesignation}
                            onChange={handleDesignationChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid item size={{md: 2, xs: 12 }}>
                        <Typography>
                            User
                        </Typography>
                        <Autocomplete
                            options={users}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} placeholder="Select User" />}
                            value={selectedUser}
                            onChange={handleUserChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid item size={{md: 2, xs: 12 }}>
                        <Typography>
                            Location
                        </Typography>
                        <Autocomplete
                            options={locations}
                            getOptionLabel={(option) => option.locationname}
                            renderInput={(params) => <TextField {...params} placeholder="Select Location" />}
                            value={selectedLocation}
                            onChange={handleLocationChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid item size={{md: 2, xs: 12 }}>
                        <Typography>
                            Year
                        </Typography>
                        <Autocomplete
                            options={years}
                            getOptionLabel={(option) => option.toString()}
                            renderInput={(params) => <TextField {...params} placeholder="Select Year" />}
                            value={selectedYear}
                            onChange={handleYearChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                </Grid>
                <DataGrid
                    rows={data}
                    columns={columns}
                    pageSize={8}
                    rowsPerPageOptions={[8]}
                    hideFooter
                    className="data-grid"
                    disableSelectionOnClick
                    getCellClassName={(params) => {
                        // Remove $ and % symbols and convert to number
                        const value = parseFloat(params.value.replace(/[$,%]/g, ''));

                        if (
                            (params.row.metric === "Collection %" || params.row.metric === "Total Bonus Earned") &&
                            params.field !== 'metric'
                        ) {
                            if (!isNaN(value) && value !== 0) {
                                return 'percent-complete-high';
                            }
                        }
                        if (!isNaN(value) && value < 0) {
                            return 'negative-value';
                        }

                        return '';
                    }}
                    sx={{
                        '& .MuiDataGrid-cell': {
                            borderBottom: 'none',
                        },
                        '& .MuiDataGrid-row': {
                            borderBottom: '2px solid #f0f0f0',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f5f5f5',
                            borderBottom: '2px solid #e0e0e0',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 'bold',
                        },
                        '& .percent-complete-high': {
                            color: 'green !important',
                            fontWeight: 'bold',
                        },
                        '& .negative-value': {
                            color: 'red',
                        },
                    }}
                />

            </Box>
        </Box>
    );
}
